module.exports = __webpack_public_path__ + "static/media/house-and-garden-footer.adf86171.svg";